import React, { useEffect } from 'react';
import './Toast.css';

const Toast = ({ type, message, onDismiss, durationMs = 4500 }) => {
  useEffect(() => {
    if (!durationMs || durationMs < 0) return undefined;
    const t = setTimeout(onDismiss, durationMs);
    return () => clearTimeout(t);
  }, [onDismiss, durationMs, message, type]);

  return (
    <div
      className={`toast toast-${type}`}
      role="alert"
      aria-live={type === 'error' ? 'assertive' : 'polite'}
    >
      <span className="toast-message">{message}</span>
      <button
        type="button"
        className="toast-dismiss"
        onClick={onDismiss}
        aria-label="Dismiss"
      >
        ×
      </button>
    </div>
  );
};

export default Toast;
